import { Navigate } from 'react-router-dom';
import {useContext, useEffect} from 'react';
import { AuthContext } from '../Context/AuthContext';
import LoaderSpinner from '../SystemDesign/LoaderSpinner'

const ProtectedRoute = ({ element: Element }) => {
    const { isAuth, isLoading,  refreshUser} = useContext(AuthContext);
    // First check if user is authenticated
    useEffect(() => {
        if (!isAuth && !isLoading) {
            refreshUser();
        }
    }, [isAuth, isLoading, refreshUser]);


    if (isLoading) {
        return <LoaderSpinner loading={true} />;
    }
    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    // User is authenticated and has required permissions
    return Element;
};

export default ProtectedRoute;